import getCurrentGroup from './getCurrentGroup';

export default function getReportingPlatform(
  state: any
): GroupReportingPlatform | undefined {
  const currentGroup = getCurrentGroup(state);
  const reportingPlatform = currentGroup?.get('reportingPlatform');
  return reportingPlatform?.toJS();
}
